// src/phoneImages.js
// Auto-import every image in src/assets/phone (non-recursive).
function natural(a, b) {
    return a.localeCompare(b, undefined, { numeric: true, sensitivity: "base" });
  }
  
  let images = [];
  try {
    const ctx = require.context("./assets/phone", false, /\.(png|jpe?g|gif|webp|avif)$/i);
    images = ctx.keys().sort(natural).map(ctx);   // -> array of URLs
  } catch (e) {
    // If this ever runs in a non-webpack env, just fall back to empty.
    images = [];
  }
  
  export default images;
  